import "./CoupangBanner.css";

interface CoupangBannerProps {
  index: number;
}
const CoupangBanner = ({ index }: CoupangBannerProps) => {
  console.log("CoupangBanner", index);

  const handleClickBanner = (url: string) => {
    console.log("handleClickBanner", url);

    (window as any).webViewOpenBrowser(url);
  };

  if ((window as any)._APP_LANG !== "ko") {
    return <></>;
  }

  return (
    <div className="coupang-banner">
      {index === 25 ? (
        <img
          src={`https://ads-partners.coupang.com/banners/826979?subId=&traceId=V0-301-2b8ef06377ec8f50-I826979&w=728&h=90`}
          alt=""
          onClick={() => handleClickBanner("https://link.coupang.com/a/b9Ef4m")}
        />
      ) : (
        <img
          src={`https://ads-partners.coupang.com/banners/812197?subId=&traceId=V0-301-371ae01f4226dec2-I812197&w=728&h=90`}
          alt=""
          onClick={() => handleClickBanner("https://link.coupang.com/a/b7uQrs")}
        />
      )}
    </div>
  );
};

export default CoupangBanner;
